<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal,
  BButton,
  BAlert,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  AlertPlugin,
  BForm,
  BFormInput,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@core/utils/validations/validations';

export default {
  components: {
    BFormInput,
    BForm,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        estabelecimentoid: '',
        estabelecimentorazaosocial: '',
        estabelecimentomodalidade: '',
        estabelecimentomodalidadedescr: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.estabelecimentorazaosocial === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Codigo"
                label-for="estabelecimentoid"
            >
              <b-form-input
                  id="estabelecimentoid"
                  v-model="dataForm.estabelecimentoid"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Razao Social"
                label-for="estabelecimentorazaosocial"
            >
              <b-form-input
                  id="estabelecimentorazaosocial"
                  v-model="dataForm.estabelecimentorazaosocial"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Empresa"
                label-for="empresaid"
            >
              <b-form-input
                  id="empresaid"
                  v-model="dataForm.empresa.empresanomefantasia"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="6"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Pais"-->
<!--                label-for="paisid"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="paisid"-->
<!--                  v-model="dataForm.pais.pais_nome"-->
<!--                  type="text"-->
<!--                  disabled-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="6"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Uf"-->
<!--                label-for="ufid"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="ufid"-->
<!--                  v-model="dataForm.uf.uf_nome"-->
<!--                  type="text"-->
<!--                  disabled-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="6"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Endereço"-->
<!--                label-for="estabelecimentoendereco"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="estabelecimentoendereco"-->
<!--                  v-model="dataForm.estabelecimentoendereco"-->
<!--                  type="text"-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="6"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Bairro"-->
<!--                label-for="estabelecimentobairro"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="estabelecimentobairro"-->
<!--                  v-model="dataForm.estabelecimentobairro"-->
<!--                  type="text"-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="6"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Cidade"-->
<!--                label-for="estabelecimentocidade"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="estabelecimentocidade"-->
<!--                  v-model="dataForm.estabelecimentocidade"-->
<!--                  type="text"-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="6"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Cep"-->
<!--                label-for="estabelecimentocep"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="estabelecimentocep"-->
<!--                  v-model="dataForm.estabelecimentocep"-->
<!--                  type="text"-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="6"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="CNPJ"-->
<!--                label-for="estabelecimentocnpj"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="estabelecimentocnpj"-->
<!--                  v-model="dataForm.estabelecimentocnpj"-->
<!--                  type="text"-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
